import React from 'react';
import { welcome } from '../../mock';

const Welcome = () => {
  return (
    <section className="bg-cream py-24 md:py-36">
      <div className="max-w-[1200px] mx-auto px-6 md:px-10 grid md:grid-cols-2 gap-14 md:gap-20 items-center">
        <div className="reveal order-2 md:order-1">
          <div className="flex items-center gap-3 mb-6">
            <span className="h-px w-10 bg-gold" />
            <span className="chapter-badge text-gold uppercase">{welcome.eyebrow}</span>
          </div>
          <h2 className="font-serif-display text-navy text-4xl md:text-5xl leading-[1.1] font-medium">
            {welcome.headline}
          </h2>
          <div className="mt-8 space-y-5">
            {welcome.body.map((p, i) => (
              <p key={i} className="font-serif-editorial text-navy/85 text-lg md:text-xl leading-relaxed">
                {p}
              </p>
            ))}
          </div>
          <div className="mt-10">
            <a href="#discover" className="link-underline text-navy uppercase text-[0.82rem] tracking-[0.14em]">
              Discover Destinations —
            </a>
          </div>
        </div>

        <div className="reveal order-1 md:order-2">
          <div className="relative aspect-[4/5] overflow-hidden">
            <img
              src={welcome.image}
              alt="Couple at sunset"
              className="w-full h-full object-cover"
              loading="lazy"
            />
            <div className="absolute inset-0 ring-1 ring-inset ring-black/5" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Welcome;
